module.exports = __webpack_public_path__ + "img/forget_password_logo.5b6f21a8.png";